import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "text-h4 text-center" }, "Site Unavailable", -1),
    _createElementVNode("div", { class: "text-body1 text-center" }, " The site you are trying to access is unavailable at this time. For more information or to make a donation, please call our office. ", -1)
  ])))
}